<template>
  <!-- <img alt="自评" src="./assets/maeva.png" style="width:150px;height:150px"> -->
  <MAEVA />
  <div class="icp">{{`© ${year} ${author} ` }}<a href="http://beian.miit.gov.cn/" target="_blank">{{ record }}</a></div>
</template>

<script>
import MAEVA from './components/ma-eva.vue'

export default {
  name: 'App',
  components: {
    MAEVA
  },
  data(){ 
    return {
      year:new Date().getFullYear(), // 一般都是最新的一年
      author:'ykx',					// 作者名
      record:'京ICP备2025111559号',
    }
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.icp {
  /* 常规文档流页脚：原先 absolute + bottom:0 相对首屏视口定位，
     页面变长后会叠印在首屏内容（如定性评价图表）上 */
  width: 100%;
  margin: 6px 0;
  white-space: pre;
  text-align: center;
  color: gray;
}
.icp > a {
    color: gray;
    text-decoration: none;
}
.icp > a:hover {
    color: aqua;
    text-decoration: none;
}
</style>
